import { CodeVerificationProps } from '../../userVerificationModal.types';
import styles from '../../userVerificationModal.module.css';
import { Trans } from 'react-i18next';
import { UserType } from '@inplay/models';
import DesktopPinInput from '../../../desktopPinInput/desktopPinInput';
import Button from '../../../button/button';
import { FC } from 'react';

export const CodeVerificationContent: FC<CodeVerificationProps> = (
  props: CodeVerificationProps,
) => (
  <div className={styles.content}>
    <h3 className={styles.title}>
      <Trans i18nKey={'userVerification.title'} />
    </h3>
    <p className={styles.descriptionCodeVerification}>
      {props.selectedUser?.type === UserType.VENUE_STAFF ||
      props.selectedUser?.type === UserType.VENUE_BRANCH_LOGIN ? (
        <>
          <Trans i18nKey="userVerification.hi" />{' '}
          <span>
            {props.selectedUser?.firstName} {props.selectedUser?.lastName}!
          </span>
          {''}
          <Trans i18nKey="userVerification.pleaseEnterYour" />{' '}
          <span>
            <Trans i18nKey="userVerification.4digitPin" />
          </span>{' '}
          <Trans i18nKey="userVerification.numberToConfirm" />
        </>
      ) : (
        <>
          <Trans i18nKey="userVerification.hi" />{' '}
          <span>
            {props.selectedUser?.firstName} {props.selectedUser?.lastName}!
          </span>{' '}
          <Trans i18nKey="userVerification.pleaseEnterOTP" />{' '}
          <span>{props.selectedUser?.email}</span>{' '}
          <Trans i18nKey="userVerification.toConfirm" />
        </>
      )}
    </p>
    <DesktopPinInput
      otp={props.code}
      setOtp={props.setCode}
      inputLength={
        props.selectedUser?.type === UserType.VENUE_STAFF ||
        props.selectedUser?.type === UserType.VENUE_BRANCH_LOGIN
          ? 4
          : 6
      }
      placeholder="0"
    />
    <button className={styles.resend} onClick={props.handleResetForgotCode}>
      <Trans
        i18nKey={
          props.selectedUser?.type === UserType.VENUE_STAFF ||
          props.selectedUser?.type === UserType.VENUE_BRANCH_LOGIN
            ? 'userVerification.forgotPin'
            : 'userVerification.resendOTP'
        }
      />
    </button>
    {(props.selectedUser?.type === UserType.VENUE_STAFF ||
      props.selectedUser?.type === UserType.VENUE_BRANCH_LOGIN) && (
      <Button
        className={styles.next}
        onClick={props.handleCodeVerification}
        disabled={props.code.length !== 4}
      >
        <Trans i18nKey="userVerification.next" />
      </Button>
    )}
  </div>
);
